/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: CenterBothAxes.tsx
 * Project: mle-client
 * Committed last: 2021/10/25 @ 1138
 * ---
 */

import styled from 'styled-components';

export const CenterBothAxes = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
